import React, { useState } from "react";
import logo from "../../src/Images/img/logo.png";
import { FaSearch, FaGift, FaCalendarCheck } from "react-icons/fa";
import {
  FaPeopleArrows,
  FaSackDollar,
  FaFileInvoiceDollar,
} from "react-icons/fa6";
import * as query from "../query";

function Home() {
  const [showAlert, setShowAlert] = useState(false);
  const [msgSent, setMsgSent] = useState(false);
  const [process, setProcess] = useState(false);
  const [formData, setFormData] = useState({
    nameInput: "",
    emailInput: "",
    msgInput: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    setShowAlert(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let $name = formData.nameInput;
    let $email = formData.emailInput;
    let $message = formData.msgInput;
    setProcess(false);

    if ($name !== "" && $email !== "" && $message !== "") {
      setShowAlert(false);
      setProcess(true);
      sendFeedbackEmail($email, $name, $message);
    } else {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }

    // alert(
    //   `Name: ${formData.nameInput}, Email: ${formData.emailInput}, Message: ${formData.msgInput}`
    // );
  };

  const sendFeedbackEmail = async (email, name, message) => {
    const response = await query.fetchOpenRequest(
      "api/share/email/feedback/send",
      {
        email,
        name,
        message,
      }
    );

    if (!response.ok) {
      const resData = await response.json();

      if (resData.response.code === 500) {
        setProcess(false);
        throw new Error(resData.response.errorMessage);
      } else throw new Error("something went wrong!");
    }

    await response.json();
    setProcess(false);
    setMsgSent(true);
    setTimeout(() => {
      setMsgSent(false);
    }, 3000);

    setFormData({
      nameInput: "",
      emailInput: "",
      msgInput: "",
    });
  };

  return (
    <div>
      <header
        id="js-header"
        class="u-header u-header--sticky-top u-header--show-hide u-header--toggle-section"
        data-header-fix-moment="100"
        data-header-fix-effect="slide"
      >
        <div class="u-header__section u-shadow-v27 g-bg-white g-transition-0_3 g-py-12 g-py-20--md">
          <nav class="navbar navbar-expand-lg py-0 g-px-15">
            <div class="container g-pos-rel">
              <a
                href={() => false}
                target="_blank"
                rel="noreferrer"
                class="js-go-to navbar-brand u-header__logo"
                data-type="static"
              >
                <img
                  class="u-header__logo-img u-header__logo-img--main g-width-200"
                  src={logo}
                  alt="Questquote logo"
                />
              </a>

              <div
                id="navBar"
                class="collapse navbar-collapse"
                data-mobile-scroll-hide="true"
              >
                <div class="navbar-collapse align-items-center flex-sm-row">
                  <ul
                    id="js-scroll-nav"
                    class="navbar-nav g-flex-right--xs text-uppercase w-100 g-font-weight-700 g-font-size-11 g-pt-20 g-pt-0--lg"
                  >
                    <li class="nav-item g-mr-15--lg g-mb-12 g-mb-0--lg active">
                      <a href="#home" class="nav-link p-0">
                        Home <span class="sr-only">(current)</span>
                      </a>
                    </li>
                    <li class="nav-item g-mx-15--lg g-mb-12 g-mb-0--lg">
                      <a href="#whyWe" class="nav-link p-0">
                        Why we
                      </a>
                    </li>
                    <li class="nav-item g-mx-15--lg g-mb-12 g-mb-0--lg">
                      <a href="#feature" class="nav-link p-0">
                        Features
                      </a>
                    </li>
                    <li class="nav-item g-mx-15--lg g-mb-12 g-mb-0--lg">
                      <a href="#faq" class="nav-link p-0">
                        FAQ
                      </a>
                    </li>
                    <li class="nav-item g-mx-15--lg g-mb-12 g-mb-0--lg">
                      <a href="#contact" class="nav-link p-0">
                        Contact
                      </a>
                    </li>
                    <li class="nav-item g-ml-15--lg g-mb-12 g-mb-0--lg">
                      <a
                        href={"https://www.questquote.com?page=privacypolicy"}
                        target="_blank"
                        rel="noopener noreferrer"
                        class="nav-link p-0"
                      >
                        Policy
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <button
                class="navbar-toggler btn g-line-height-1 g-brd-none g-pa-0 g-pos-abs g-top-15 g-right-0"
                type="button"
                aria-label="Toggle navigation"
                aria-expanded="false"
                aria-controls="navBar"
                data-toggle="collapse"
                data-target="#navBar"
              >
                <span class="hamburger hamburger--slider">
                  <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                  </span>
                </span>
              </button>
            </div>
          </nav>
        </div>
      </header>

      <section id="home" class="g-theme-bg-gray-light-v1 g-pt-90">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-lg-5 ml-lg-auto d-flex text-center text-md-left g-font-size-16">
              <div class="align-self-center">
                <h2 class="text-uppercase g-line-height-1_3 g-font-size-36 g-mb-20 g-mb-30--lg">
                  <strong>Grow your business</strong>
                  <br />
                  Grow Your Network
                </h2>
                <p class="g-mb-20 g-mb-35--lg">
                  Questquote is an innovative platform designed to facilitate
                  interaction and collaboration among professionals and service
                  providers from various industries to forming a diverse
                  community network. Whatever professional assistance or
                  business collaboration you need, you can find satisfactory
                  solutions here to help you achieve business growth and
                  development.
                </p>
                <a
                  href="https://apps.apple.com/my/app/questquote/id6670389727"
                  class="btn btn-md u-btn-primary g-font-weight-700 text-uppercase text-left g-rounded-10 g-py-10 g-mb-15 g-mx-10 g-mx-0--md g-mr-30--md"
                >
                  <span class="float-right g-font-size-13">
                    Download App
                    <span class="d-block g-font-size-10 g-font-weight-400 g-opacity-0_6">
                      From App Store
                    </span>
                  </span>
                  <i class="fa fa-apple float-left g-font-size-26 g-mr-15"></i>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.questquote.QuestQuote"
                  class="btn btn-md u-btn-darkpurple g-font-weight-700 text-uppercase text-left g-rounded-10 g-py-10 g-mb-15 g-mx-10 g-mx-0--md"
                >
                  <span class="float-right g-font-size-13">
                    Download App
                    <span class="d-block g-font-size-10 g-font-weight-400 g-opacity-0_6">
                      From Play Store
                    </span>
                  </span>
                  <i class="fa fa-android float-left g-font-size-26 g-mr-15"></i>
                </a>
              </div>
            </div>

            <div class="col-md-6 col-lg-6 g-overflow-hidden">
              <img
                class="img-fluid"
                src={require("../../src/Images/img-temp/mockups/mockup7.png")}
                alt="App Content"
                data-animation="slideInUp"
              />
            </div>
          </div>
        </div>
      </section>

      <section id="whyWe" class="container g-pt-100 g-pb-70">
        <div class="container text-center g-max-width-750 g-font-size-16 g-mb-65">
          <div class="text-uppercase g-line-height-1_3 g-mb-20">
            <h2 class="g-line-height-1_3 g-font-size-36 mb-0">
              Expand Your Network, <strong>Amplify Your Success</strong>
            </h2>
          </div>

          <p class="mb-0">
            Building Bridges, Breaking Boundaries, Where Collaboration Leads to
            Innovation.
          </p>
        </div>

        <div class="row">
          <div class="offset-lg-1 col-lg-5 g-mb-30">
            <article class="u-shadow-v22">
              <figure class="g-pos-rel">
                <img
                  class="img-fluid w-100"
                  src={require("../../src/Images/img-temp/benefits/presentation.jpeg")}
                  alt="presentation"
                />
              </figure>

              <div class="g-pa-20">
                <h3 class="h4 g-font-weight-500 g-mb-15">
                  <a
                    class="u-link-v5 g-color-main g-color-primary--hover g-text-underline--none--hover"
                    href={() => false}
                  >
                    Sharing Professional Knowledge
                  </a>
                </h3>

                <div class="g-mb-30">
                  <p>
                    At Questquote, members can share their expertise and
                    experiences to help and support others within the groups.
                    Whether you're an IT expert, marketing specialist, designer,
                    or professional in any other field, you can find like-minded
                    partners here to grow together.
                  </p>
                </div>
              </div>
            </article>
          </div>

          <div class="col-lg-5 g-mb-30">
            <article class="u-shadow-v22">
              <figure class="g-pos-rel">
                <img
                  class="img-fluid w-100"
                  src={require("../../src/Images/img-temp/benefits/shakehand.jpg")}
                  alt="Sharing"
                />
              </figure>

              <div class="g-pa-20">
                <h3 class="h4 g-font-weight-500 g-mb-15">
                  <a
                    class="u-link-v5 g-color-main g-color-primary--hover g-text-underline--none--hover"
                    href={() => false}
                  >
                    Service Exchange and Recommendations
                  </a>
                </h3>

                <div class="g-mb-30">
                  <p>
                    In addition to sharing professional knowledge, members can
                    utilize the platform's service exchange feature to promote
                    their services or products to others. Through interaction
                    with other members, you can not only expand your business
                    reach but also earn rewards and recognition.
                  </p>
                </div>
              </div>
            </article>
          </div>

          <div class="offset-lg-1 col-lg-5 g-mb-30">
            <article class="u-shadow-v22">
              <figure class="g-pos-rel">
                <img
                  class="img-fluid w-100"
                  src={require("../../src/Images/img-temp/benefits/search.jpg")}
                  alt="Searching"
                />
              </figure>

              <div class="g-pa-20">
                <h3 class="h4 g-font-weight-500 g-mb-15">
                  <a
                    class="u-link-v5 g-color-main g-color-primary--hover g-text-underline--none--hover"
                    href={() => false}
                  >
                    Convenient Search and Business Growth
                  </a>
                </h3>

                <div class="g-mb-30">
                  <p>
                    Questquote offers powerful and convenient search functions,
                    allowing you to easily find high-quality services provided
                    by other members within the groups. Whatever professional
                    assistance or business collaboration you need, you can find
                    satisfactory solutions here to help you achieve business
                    growth and development.
                  </p>
                </div>
              </div>
            </article>
          </div>

          <div class="col-lg-5 g-mb-30">
            <article class="u-shadow-v22">
              <figure class="g-pos-rel">
                <img
                  class="img-fluid w-100"
                  src={require("../../src/Images/img-temp/benefits/collaboration.jpg")}
                  alt="collaboration"
                />
              </figure>

              <div class="g-pa-20">
                <h3 class="h4 g-font-weight-500 g-mb-15">
                  <a
                    class="u-link-v5 g-color-main g-color-primary--hover g-text-underline--none--hover"
                    href={() => false}
                  >
                    Mutual Benefit and Collaboration
                  </a>
                </h3>

                <div class="g-mb-30">
                  <p>
                    We believe that on Questquote, members will work together to
                    achieve mutual benefits and create a prosperous community
                    ecosystem. Whether you're seeking help or willing to share
                    experiences, we welcome your participation in building a
                    better future together!
                  </p>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section id="feature" class="g-bg-secondary">
        <div class="container g-pt-100 g-pb-40">
          <div class="row justify-content-center g-mb-60">
            <div class="col-lg-7">
              <div class="text-center">
                <h2 class="h3 g-color-black text-uppercase mb-2">
                  Main Features
                </h2>
                <div class="d-inline-block g-width-35 g-height-2 g-bg-primary mb-2"></div>
                <p class="lead mb-0">
                  Quesquote focusing to facilitate communication among members
                  to enhance business expansion, hence we provide multiple
                  powerful features to achieve our goal.
                </p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-4 align-self-center g-mb-30">
              <div class="media g-mb-30">
                <div class="d-flex mr-4">
                  <span
                    class="u-icon-v3 u-icon-size--sm g-bg-primary rounded-circle"
                    style={{ paddingTop: 3 }}
                  >
                    <FaSearch size={23} color={"fff"} />
                  </span>
                </div>
                <div class="media-body">
                  <h3 class="h5 g-color-black mb-20">Service Searching</h3>
                  <p class="g-color-gray-dark-v4">
                    Search for members within the group who provide relevant
                    services, displaying the complete company profile of the
                    members.
                  </p>
                </div>
              </div>
              <div class="media g-mb-30">
                <div class="d-flex mr-4">
                  <span
                    class="u-icon-v3 u-icon-size--sm g-bg-primary rounded-circle"
                    style={{ paddingTop: 3 }}
                  >
                    <FaSackDollar size={23} color={"fff"} />
                  </span>
                </div>
                <div class="media-body">
                  <h3 class="h5 g-color-black mb-20">Group Fund</h3>
                  <p class="g-color-gray-dark-v4">
                    Transparent group funds allow members to have a clearer
                    insight into the financial movements of the group.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-lg-4 align-self-center g-mb-30">
              <div class="media g-mb-30">
                <div class="d-flex mr-4">
                  <span
                    class="u-icon-v3 u-icon-size--sm g-bg-primary rounded-circle"
                    style={{ paddingTop: 3 }}
                  >
                    <FaPeopleArrows size={23} color={"fff"} />
                  </span>
                </div>
                <div class="media-body">
                  <h3 class="h5 g-color-black mb-20">Member Referral</h3>
                  <p class="g-color-gray-dark-v4">
                    Accurately record referrals between members. An effective
                    referral requires mutual agreement from both parties.
                  </p>
                </div>
              </div>
              <div class="media g-mb-30">
                <div class="d-flex mr-4">
                  <span
                    class="u-icon-v3 u-icon-size--sm g-bg-primary rounded-circle"
                    style={{ paddingTop: 3 }}
                  >
                    <FaFileInvoiceDollar size={23} color={"fff"} />
                  </span>
                </div>
                <div class="media-body">
                  <h3 class="h5 g-color-black mb-20">Group Billing</h3>
                  <p class="g-color-gray-dark-v4">
                    Able to create group billing for all members or specific
                    member, and keep track of members' repayment records
                    effectively.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-lg-4 align-self-center g-mb-30">
              <div class="media g-mb-30">
                <div class="d-flex mr-4">
                  <span
                    class="u-icon-v3 u-icon-size--sm g-bg-primary rounded-circle"
                    style={{ paddingTop: 3 }}
                  >
                    <FaGift size={23} color={"fff"} />
                  </span>
                </div>
                <div class="media-body">
                  <h3 class="h5 g-color-black mb-20">Referral Gift</h3>
                  <p class="g-color-gray-dark-v4">
                    Allow members to express gratitude to the referring member
                    by giving gifts. Strengthen and promotes collaboration among
                    members.
                  </p>
                </div>
              </div>
              <div class="media g-mb-30">
                <div class="d-flex mr-4">
                  <span
                    class="u-icon-v3 u-icon-size--sm g-bg-primary rounded-circle"
                    style={{ paddingTop: 3 }}
                  >
                    <FaCalendarCheck size={23} color={"fff"} />
                  </span>
                </div>
                <div class="media-body">
                  <h3 class="h5 g-color-black mb-20">Group Events</h3>
                  <p class="g-color-gray-dark-v4">
                    Able to holding events, posting relevant information about
                    events, and managing member attendance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="faq" class="g-bg-gray-gradient-opacity-v1">
        <div class="container g-py-100">
          <div class="row justify-content-center">
            <div class="col-lg-10">
              <div class="text-center g-mb-60">
                <div class="d-inline-block g-width-35 g-height-1 g-bg-primary mb-2"></div>
                <h2 class="g-color-black g-font-weight-600 mb-2">
                  Frequently Asked Questions
                </h2>
                <p class="lead g-width-60x--md mx-auto">
                  Let us help you get to know our platform better.
                </p>
              </div>

              <div
                id="accordion"
                class="u-accordion u-accordion-color-primary"
                role="tablist"
                aria-multiselectable="true"
              >
                <div class="card g-brd-none rounded g-mb-20">
                  <div id="accordion-heading-01" class="g-pa-0" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed d-flex justify-content-between u-shadow-v19 g-color-main g-text-underline--none--hover rounded g-px-30 g-py-20"
                        href="#accordion-body-01"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        aria-expanded="false"
                        aria-controls="accordion-body-01"
                      >
                        What is our platform primarily for?
                        <span class="u-accordion__control-icon g-color-primary">
                          <i class="fa fa-angle-down"></i>
                          <i class="fa fa-angle-up"></i>
                        </span>
                      </a>
                    </h5>
                  </div>
                  <div
                    id="accordion-body-01"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="accordion-heading-01"
                    data-parent="#accordion"
                  >
                    <div class="u-accordion__body g-color-gray-dark-v4 g-pa-30 text-md-left">
                      Our platform's main purpose is to provide businesses with
                      a space to showcase their services and connect with other
                      businesses, fostering collaboration to achieve business
                      expansion goals.
                    </div>
                  </div>
                </div>

                <div class="card g-brd-none rounded g-mb-20">
                  <div id="accordion-heading-02" class="g-pa-0" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed d-flex justify-content-between u-shadow-v19 g-color-main g-text-underline--none--hover rounded g-px-30 g-py-20"
                        href="#accordion-body-02"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        aria-expanded="false"
                        aria-controls="accordion-body-02"
                      >
                        What is a group?
                        <span class="u-accordion__control-icon g-color-primary">
                          <i class="fa fa-angle-down"></i>
                          <i class="fa fa-angle-up"></i>
                        </span>
                      </a>
                    </h5>
                  </div>
                  <div
                    id="accordion-body-02"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="accordion-heading-02"
                    data-parent="#accordion"
                  >
                    <div class="u-accordion__body g-color-gray-dark-v4 g-pa-30 text-md-left">
                      While platform information can give businesses a general
                      understanding of your company, face-to-face offline
                      interactions can significantly enhance networking
                      effectiveness. The group concept brings together
                      businesses from various industries within specific
                      geographic regions to form small communities. Members
                      regularly participate in group-organized activities to
                      promote interaction between businesses.
                    </div>
                  </div>
                </div>

                <div class="card g-brd-none rounded g-mb-20">
                  <div id="accordion-heading-03" class="g-pa-0" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed d-flex justify-content-between u-shadow-v19 g-color-main g-text-underline--none--hover rounded g-px-30 g-py-20"
                        href="#accordion-body-03"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        aria-expanded="false"
                        aria-controls="accordion-body-03"
                      >
                        What's the difference between group admin and group
                        member?
                        <span class="u-accordion__control-icon g-color-primary">
                          <i class="fa fa-angle-down"></i>
                          <i class="fa fa-angle-up"></i>
                        </span>
                      </a>
                    </h5>
                  </div>
                  <div
                    id="accordion-body-03"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="accordion-heading-03"
                    data-parent="#accordion"
                  >
                    <div class="u-accordion__body g-color-gray-dark-v4 g-pa-30 text-md-left">
                      <span className="g-font-weight-700">Group Admin</span>{" "}
                      primary responsibility is to establish and manage a group
                      effectively. They organize group activities and help all
                      group members integrate well within the group.
                      <br />
                      <br />
                      <span className="g-font-weight-700">
                        Group Member
                      </span>{" "}
                      are representatives from different companies. As a group
                      member, you should actively introduce your company and
                      services to other group members to generate more referrals
                      and achieve business expansion goals.
                    </div>
                  </div>
                </div>

                <div class="card g-brd-none rounded g-mb-20">
                  <div id="accordion-heading-04" class="g-pa-0" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed d-flex justify-content-between u-shadow-v19 g-color-main g-text-underline--none--hover rounded g-px-30 g-py-20"
                        href="#accordion-body-04"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        aria-expanded="false"
                        aria-controls="accordion-body-04"
                      >
                        What is a referral?
                        <span class="u-accordion__control-icon g-color-primary">
                          <i class="fa fa-angle-down"></i>
                          <i class="fa fa-angle-up"></i>
                        </span>
                      </a>
                    </h5>
                  </div>
                  <div
                    id="accordion-body-04"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="accordion-heading-04"
                    data-parent="#accordion"
                  >
                    <div class="u-accordion__body g-color-gray-dark-v4 g-pa-30 text-md-left">
                      Referrals serve as an important collaboration bridge
                      between group members. When other group members understand
                      your company's core business and either use your services
                      when needed or introduce other customers to you, this
                      constitutes a referral. Receiving more referrals will
                      significantly contribute to your company's growth.
                    </div>
                  </div>
                </div>

                <div class="card g-brd-none rounded g-mb-20">
                  <div id="accordion-heading-05" class="g-pa-0" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed d-flex justify-content-between u-shadow-v19 g-color-main g-text-underline--none--hover rounded g-px-30 g-py-20"
                        href="#accordion-body-05"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        aria-expanded="false"
                        aria-controls="accordion-body-05"
                      >
                        What is referral credit?
                        <span class="u-accordion__control-icon g-color-primary">
                          <i class="fa fa-angle-down"></i>
                          <i class="fa fa-angle-up"></i>
                        </span>
                      </a>
                    </h5>
                  </div>
                  <div
                    id="accordion-body-05"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="accordion-heading-05"
                    data-parent="#accordion"
                  >
                    <div class="u-accordion__body g-color-gray-dark-v4 g-pa-30 text-md-left">
                      When other group members provide you with a referral, you
                      can express gratitude by giving them referral credit.
                      Receiving more referral credit indicates higher activity
                      levels within the group. Referral credits are stored in
                      your wallet but are kept separate from top-up credits.
                    </div>
                  </div>
                </div>

                <div class="card g-brd-none rounded g-mb-20">
                  <div id="accordion-heading-06" class="g-pa-0" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed d-flex justify-content-between u-shadow-v19 g-color-main g-text-underline--none--hover rounded g-px-30 g-py-20"
                        href="#accordion-body-06"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        aria-expanded="false"
                        aria-controls="accordion-body-06"
                      >
                        Where can credits be used?
                        <span class="u-accordion__control-icon g-color-primary">
                          <i class="fa fa-angle-down"></i>
                          <i class="fa fa-angle-up"></i>
                        </span>
                      </a>
                    </h5>
                  </div>
                  <div
                    id="accordion-body-06"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="accordion-heading-06"
                    data-parent="#accordion"
                  >
                    <div class="u-accordion__body g-color-gray-dark-v4 g-pa-30 text-md-left">
                      Credits can be used as gifts for other members or to pay
                      group bills.
                    </div>
                  </div>
                </div>

                <div class="card g-brd-none rounded g-mb-20">
                  <div id="accordion-heading-07" class="g-pa-0" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed d-flex justify-content-between u-shadow-v19 g-color-main g-text-underline--none--hover rounded g-px-30 g-py-20"
                        href="#accordion-body-07"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        aria-expanded="false"
                        aria-controls="accordion-body-07"
                      >
                        What is a group bill?
                        <span class="u-accordion__control-icon g-color-primary">
                          <i class="fa fa-angle-down"></i>
                          <i class="fa fa-angle-up"></i>
                        </span>
                      </a>
                    </h5>
                  </div>
                  <div
                    id="accordion-body-07"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="accordion-heading-07"
                    data-parent="#accordion"
                  >
                    <div class="u-accordion__body g-color-gray-dark-v4 g-pa-30 text-md-left">
                      Group admins can issue group bills to collect fees from
                      specified members or all members (examples: venue costs or
                      dining expenses). All collected fees go into the group
                      fund.
                    </div>
                  </div>
                </div>

                <div class="card g-brd-none rounded g-mb-20">
                  <div id="accordion-heading-08" class="g-pa-0" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed d-flex justify-content-between u-shadow-v19 g-color-main g-text-underline--none--hover rounded g-px-30 g-py-20"
                        href="#accordion-body-08"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        aria-expanded="false"
                        aria-controls="accordion-body-08"
                      >
                        What is a group fund?
                        <span class="u-accordion__control-icon g-color-primary">
                          <i class="fa fa-angle-down"></i>
                          <i class="fa fa-angle-up"></i>
                        </span>
                      </a>
                    </h5>
                  </div>
                  <div
                    id="accordion-body-08"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="accordion-heading-08"
                    data-parent="#accordion"
                  >
                    <div class="u-accordion__body g-color-gray-dark-v4 g-pa-30 text-md-left">
                      All fees collected from group bills are deposited into the
                      group fund. Only group admins have the authority to
                      withdraw money from the group fund. Group admins must
                      apply to the platform for withdrawals with justification.
                      The platform will email all group members for
                      notification. If no member feedback is received within
                      three days, the withdrawal request will be approved,
                      ensuring fairness and transparency of the group fund.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" class="g-bg-primary g-pt-90 g-pb-30 g-pb-90--lg">
        <div class="container">
          <div class="row">
            <div
              class="col-lg-5 g-mb-20 g-mb-0--lg"
              style={{ textAlign: "left" }}
            >
              <div class="text-uppercase g-mb-20">
                <h2 class="g-font-size-36 g-color-white mb-0">
                  Answers to <strong>your questions</strong>
                </h2>
              </div>

              <p class="g-font-size-16 g-color-white mb-0">
                Please feel free to contact us, and we will do our best to
                assist you.
              </p>
            </div>

            <div class="col-lg-7 g-pt-30--lg">
              <form onSubmit={handleSubmit}>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group g-mb-30">
                      <input
                        name="nameInput"
                        id="nameInput"
                        class="form-control h-100 g-color-white g-placeholder-inherit g-bg-transparent g-bg-transparent--focus g-brd-white g-rounded-10 g-px-20 g-py-10"
                        type="text"
                        placeholder="Name"
                        value={formData.nameInput}
                        onChange={handleChange}
                      />
                    </div>

                    <div class="form-group g-mb-30">
                      <input
                        name="emailInput"
                        id="emailInput"
                        class="form-control h-100 g-color-white g-placeholder-inherit g-bg-transparent g-bg-transparent--focus g-brd-white g-rounded-10 g-px-20 g-py-10"
                        type="email"
                        placeholder="Email *"
                        value={formData.emailInput}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group g-mb-30">
                      <textarea
                        name="msgInput"
                        id="msgInput"
                        class="form-control g-resize-none g-color-white g-placeholder-inherit g-bg-transparent g-bg-transparent--focus g-brd-white g-rounded-10 g-px-20 g-py-10"
                        rows="5"
                        placeholder="Message"
                        value={formData.msgInput}
                        onChange={handleChange}
                      ></textarea>
                    </div>

                    <div class="text-center text-md-right">
                      {process === true ? (
                        <button
                          class="btn u-btn-white btn-md text-uppercase g-font-weight-700 g-font-size-12 g-color-black g-rounded-10 g-py-10 g-px-25 mb-0"
                          type="submit"
                          disabled
                        >
                          Submitting...
                        </button>
                      ) : (
                        <button
                          class="btn u-btn-white btn-md text-uppercase g-font-weight-700 g-font-size-12 g-color-black g-rounded-10 g-py-10 g-px-25 mb-0"
                          type="submit"
                        >
                          Submit
                        </button>
                      )}
                    </div>

                    {showAlert && (
                      <div
                        class="alert alert-danger g-mt-30--lg"
                        role="alert"
                        style={{ textAlign: "left" }}
                      >
                        <strong>
                          Name, Email and Message cannot be empty.
                        </strong>
                      </div>
                    )}
                    {msgSent && (
                      <div
                        class="alert alert-success g-mt-30--lg"
                        role="alert"
                        style={{ textAlign: "left" }}
                      >
                        <strong>Thank you for your feedback!</strong>
                        <br />
                        <span>we truly appreciate your valuable input.</span>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <a
        class="js-go-to u-go-to-v1"
        href={() => false}
        data-type="fixed"
        data-position='{
     "bottom": 15,
     "right": 15
   }'
        data-offset-top="400"
        data-compensation="#js-header"
        data-show-effect="zoomIn"
      >
        <i class="hs-icon hs-icon-arrow-top"></i>
      </a>
    </div>
  );
}

export default Home;
